import cn from 'clsx';
import { FC, ReactNode } from 'react';

import { TextButtonModel } from '../../../types';
import TextButton from '../../Button/Text';

import s from './HeadlineTitle.module.scss';

type HeadlineTitleSizeType = 'small' | 'medium' | 'large';

export interface HeadlineTitleProps {
  size?: HeadlineTitleSizeType;
  title?: string | ReactNode;
  subText?: string | ReactNode;
  button?: TextButtonModel;
  className?: string;
}

const HeadlineTitle: FC<React.PropsWithChildren<React.PropsWithChildren<HeadlineTitleProps>>> = ({ size = 'medium', title, subText, button, className }) => {
  return (
    <div className={cn(s.wrap, s[size], className)}>
      <div className={cn(s.innerWrap)}>
        <h1 className={cn(s.title, s[size])}>{title}</h1>
        {button && (
          <TextButton size="small" {...button}>
            {button.label}
          </TextButton>
        )}
      </div>
      {size !== 'small' && subText && <p className={cn(s.sub_text, s[size])}>{subText}</p>}
    </div>
  );
};

export default HeadlineTitle;
